import { render } from "./TableData2Setting.vue?vue&type=template&id=75650d75&scoped=true"
import script from "./TableData2Setting.vue?vue&type=script&lang=js"
export * from "./TableData2Setting.vue?vue&type=script&lang=js"

import "./TableData2Setting.vue?vue&type=style&index=0&id=75650d75&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75650d75"],['__file',"src/views/h5/common/sys/miniProgram/setting/component/TableData2Setting.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "75650d75"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('75650d75', __exports__)) {
    api.reload('75650d75', __exports__)
  }
  
  module.hot.accept("./TableData2Setting.vue?vue&type=template&id=75650d75&scoped=true", () => {
    api.rerender('75650d75', render)
  })

}


export default __exports__